<div class="app-assinaturas-usuario">
    <app-dados-pessoais></app-dados-pessoais>
    <app-cartoes></app-cartoes>
    <app-assinaturas></app-assinaturas>
    <app-faturas></app-faturas>
</div>
  
